export enum SignOffDecision {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export type GrantApprovalStatus =
  | "PENDING"
  | "APPROVED"
  | "REJECTED"
  | "EXPIRED"
  | "RECOMMEND_CHANGE";

export const APPROVER_STATUS_LABELS: Record<GrantApprovalStatus, string> = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  RECOMMEND_CHANGE: "Change Recommended",
};

export const FILTERABLE_GRANT_APPROVAL_STATUSES: GrantApprovalStatus[] = [
  "PENDING",
  "APPROVED",
  "REJECTED",
  "RECOMMEND_CHANGE",
];

export type OnExpiryAction = "AUTO_APPROVE" | "AUTO_REJECT";

export interface GrantApprovalMetaData {
  notifiedAt?: string;
  expiresAt?: string;
  respondedAt?: string;
  onExpiryAction?: OnExpiryAction;
  autoActed?: boolean;
}

// One row in the GrantApproval table — one per approver per grant
export interface GrantApproval {
  id: string;
  grantId: string;
  userId: string;
  approverName: string;
  approverEmail?: string;
  order: number;
  status: GrantApprovalStatus;
  comment?: string;
  metaData?: GrantApprovalMetaData;
  recommendations?: {
    proposedChanges?: Record<string, any> | null;
  }[];
}

// Derived flow-level status (not stored — computed from rows)
export type ApprovalFlowStatus =
  | "IN_PROGRESS"
  | "COMPLETED"
  | "REJECTED"
  | "RECOMMEND_CHANGE";

export function deriveFlowStatus(
  rows: GrantApproval[] | undefined | null,
  minApprovers?: number
): ApprovalFlowStatus {
  if (!rows?.length) return "IN_PROGRESS";
  if (rows.some((r) => r.status === "REJECTED")) return "REJECTED";
  if (rows.some((r) => r.status === "RECOMMEND_CHANGE"))
    return "RECOMMEND_CHANGE";
  const approvedCount = rows.filter((r) => r.status === "APPROVED").length;
  const required = minApprovers ?? rows.length;
  if (approvedCount >= required) return "COMPLETED";
  return "IN_PROGRESS";
}
